import { formatDateDMY } from "@me-team/host/src/utils/utils";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface IModalProductInfoProps {
    date?: string;
    productName?: string;
    brand?: string;
    categoryName?: string;
    sku?: string;
    barcode?: string;
    unitGroupName?: string;
    remnants?: string;
}

const ModalProductInfo: React.FC<IModalProductInfoProps> = ({
    date,
    productName,
    brand,
    categoryName,
    sku,
    barcode,
    unitGroupName,
    remnants,
}) => {
    const { t } = useTranslation();
    return (
        <>
            <Row className="mx-0">
                <Col sm={3} xs={4}>
                    <div className="text-dark fw-bold fs-7">{t("Date and time of creation of the transaction")}</div>
                </Col>
                <Col sm={9} xs={8}>
                    {date && <div className="text-dark fs-7">{formatDateDMY(date)}</div>}
                </Col>
            </Row>
            <Row className="mx-0 mt-3">
                <Col sm={3} xs={4}>
                    <div className="text-dark fw-bold fs-7">{t("Product name")}</div>
                </Col>
                <Col sm={9} xs={8}>
                    <div className="text-dark fs-7">{productName}</div>
                </Col>
            </Row>
            <Row className="mx-0 mt-3">
                <Col sm={3} xs={4}>
                    <div className="text-dark fw-bold fs-7">{t("ProductsList.Brand")}</div>
                </Col>
                <Col sm={9} xs={8}>
                    <div className="text-dark fs-7">{brand}</div>
                </Col>
            </Row>
            <Row className="mx-0 mt-3">
                <Col sm={3} xs={4}>
                    <div className="text-dark fw-bold fs-7">{t("ProductsList.Category")}</div>
                </Col>
                <Col sm={9} xs={8}>
                    <div className="text-dark fs-7">{categoryName}</div>
                </Col>
            </Row>
            <Row className="mx-0 mt-3">
                <Col sm={3} xs={4}>
                    <div className="text-dark fw-bold fs-7">{t("ProductsList.SKU")}</div>
                </Col>
                <Col sm={9} xs={8}>
                    <div className="text-dark fs-7">{sku ? sku : "-"}</div>
                </Col>
            </Row>
            <Row className="mx-0 mt-3">
                <Col sm={3} xs={4}>
                    <div className="text-dark fw-bold fs-7">{t("ProductsList.Barcode")}</div>
                </Col>
                <Col sm={9} xs={8}>
                    <div className="text-dark fs-7">{barcode ? barcode : "-"}</div>
                </Col>
            </Row>
            <Row className="mx-0 mt-3">
                <Col sm={3} xs={4}>
                    <div className="text-dark fw-bold fs-7">{t("Unit group")}</div>
                </Col>
                <Col sm={9} xs={8}>
                    <div className="text-dark fs-7">{unitGroupName}</div>
                </Col>
            </Row>
            <Row className="mx-0 mt-3">
                <Col sm={3} xs={4}>
                    <div className="text-dark fw-bold fs-7">{t("Remnants")}</div>
                </Col>
                <Col sm={9} xs={8}>
                    <div className="text-dark fs-7">{remnants}</div>
                </Col>
            </Row>
        </>
    );
};

export default ModalProductInfo;
